var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { get } from '../../../../utils/get';
import { CONTEXT_PROPS } from '../../../../types/ContextProps';
import { IDs } from '../adapter-blog-post';
import { getImageObject } from '../../../../adapters/structure-data-utils';
export var renderStructureData = function (item, calculatedData) {
    if (calculatedData[IDs.SD_DISABLE_SCHEMA]) {
        return {};
    }
    var _a = calculatedData, _b = IDs.AUTHOR, author = _a[_b], _c = IDs.AUTHOR_IMAGE_HEIGHT, authorImageHeight = _a[_c], _d = IDs.AUTHOR_IMAGE_WIDTH, authorImageWidth = _a[_d], _e = IDs.AUTHOR_IMAGE_URL, authorImageUrl = _a[_e], _f = IDs.CATEGORIES, articleSection = _a[_f], _g = IDs.LAST_MODIFIED_DATE, dateModified = _a[_g], _h = IDs.PUBLISH_DATE, datePublished = _a[_h], _j = IDs.HEADLINE, headline = _a[_j], _k = IDs.POST_PAGE_URL, url = _a[_k], _l = IDs.DESCRIPTION, description = _a[_l], _m = IDs.COVER_IMAGE_HEIGHT, coverImageHeight = _a[_m], _o = IDs.COVER_IMAGE_WIDTH, coverImageWidth = _a[_o], _p = IDs.COVER_IMAGE, coverImageUrl = _a[_p];
    return __assign(__assign({ '@context': 'https://schema.org', '@type': 'BlogPosting', author: __assign({ '@type': 'Person', name: author }, getImageObject('image', authorImageUrl, authorImageWidth, authorImageHeight)), articleSection: articleSection,
        dateModified: dateModified,
        datePublished: datePublished, headline: headline, mainEntityOfPage: {
            '@id': url,
            '@type': 'itemPage',
            url: url,
        }, description: description,
        url: url }, getImageObject('image', coverImageUrl, coverImageWidth, coverImageHeight)), { publisher: __assign({ '@type': 'Organization', name: get(item, "context." + CONTEXT_PROPS.SITE_NAME) }, getImageObject('logo', get(item, "context." + CONTEXT_PROPS.BUSINESS_LOGO))) });
};
